export default __webpack_public_path__ + "static/media/arrow-left-circle.01a9bdf0.svg";